(function(app, ng) {

    app.provider("AuthService", [function() {
        this.$get = ["permissionService", "$q", "$cookies", "portalBaseApiUrl", function (permissionService, $q, $cookies, portalBaseApiUrl) {
            return {
                login: login,
                logout: logout,
                isAuthenticated: isAuthenticated
            };

            function login(userGroupId, redirect) {
                var url = portalBaseApiUrl + "/Login/Fig/Redirect?redirectUri=" + window.encodeURIComponent(window.location.protocol + "//" + window.location.host);

                if (redirect && redirect.toLowerCase().includes("marketingtracker")) url += window.encodeURIComponent('/' + redirect)
                else url += '/Portal/Dashboard';

                if (userGroupId) url += "&theme=" + userGroupId;
                window.location = url;
            }

            function logout() {
                permissionService.removeStoredPermissions();
                permissionService.removeStoredOnBehalfOfUserId();
                localStorage.removeItem("Auth.MarketingTrackerAccessToken");
                window.location = portalBaseApiUrl + "/Logout/Fig/Redirect?redirectUri=" + window.encodeURIComponent(window.location.protocol + "//" + window.location.host + "/v1/#/Login?msg=logout");
            }

            function isAuthenticated() {
                // TODO: set timer for modal
                var timerCookie = $cookies.get(".timer.portal");
                console.log("checking cookie", document.cookie, timerCookie);
                if (!timerCookie) return $q.when(false);
                var expiration = new Date(timerCookie);
                if (window.isNaN(expiration.getTime())) return $q.when(false);
                var isValid = expiration > new Date();
                if (!isValid) {
                    // if they somehow had an old timer cookie from the old domain, clear it now
                    $cookies.remove(".timer.portal", { domain: ".figmarketing.com" });
                }
                return $q.when(isValid);
            }
        }];
    }]);

    // TODO: remove this whole block once api domain has finished moving for UI
    app.run(["portalApiGateway", "portalBaseApiUrl", function (api, portalBaseApiUrl) {
        if (portalBaseApiUrl === "/api") return; // only need to add withCredentials interceptor if we are targeting old api

        api.addInterceptor(["AuthService", function (AuthService) {
            return {
                request: function (config) {
                    config.withCredentials = true;
                    return config;
                }
            };
        }]);
    }]);

    app.run([
        "portalApiGateway", function(api) {
            api.addInterceptor([
                "permissionService", function(permissionService) {
                    return {
                        request: function(config) {
                            // TODO: remove this after a week or so once we remove localstorage from permissionService.js
                            var id = permissionService.getOnBehalfOfUserId();
                            if (id)
                                config.headers["X-On-Behalf-Of"] = id;
                            return config;
                        }
                    };
                }
            ]);
        }
    ]);

    //temporary
    app.run(["AuthService", "portalApiGateway", function(auth, api) { window.auth = auth;window.api = api;}]);

})(window.app, window.angular); //jshint ignore:line